export default __webpack_public_path__ + "static/media/1957.20b8128f.png";